import type { GetPolygonBounds } from "./types";

// The axis-aligned box around the ring; empty rings give an inverted box that contains nothing.
export const getPolygonBounds: GetPolygonBounds = ({ points }) => {
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  for (const point of points) {
    if (point.x < minX) minX = point.x;
    if (point.y < minY) minY = point.y;
    if (point.x > maxX) maxX = point.x;
    if (point.y > maxY) maxY = point.y;
  }
  return { minX, minY, maxX, maxY };
};
